
import React, { useRef, useState } from "react";
import "./configurationTypes.css"
import {useSelector} from 'react-redux';
import { ConfigDashboardTypes } from "../../types";
import store from "../../stateManagement/store";
import { updateActiveConfigType } from "../../stateManagement/actions/configDashboardActions";
import { useNavigate } from "react-router-dom";
import { NavbarConfigurationTile } from "../configurationTile/navbarConfigurationTile";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";
import { routesRequiringClientConfigFetch } from "./utils";
import { fetchAndStoreClientConfig } from "../../services/configurationService";
import { useDispatch } from "react-redux";
import { setDayEndPopup } from "../../stateManagement/actions/dayEndActions";
import { checkDayEndStatus, isFeatureValid } from "../dms_common/DayEndUtils";

export function NavbarConfigurationTypes() {
    const { translate } = usePortalTranslation();
    const CUR_COMPONENT = "Navbar Options"

    const containerRef = useRef<HTMLDivElement>(null);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
    
    const dispatch = useDispatch();

    const handleMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
      if (containerRef.current) {
        setIsDragging(true);
        setStartX(e.pageX - containerRef.current.offsetLeft);
        setScrollLeft(containerRef.current.scrollLeft);
      }
    };

    const handleMouseUp = () => {
      setIsDragging(false);
    };

    const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
      if (!isDragging || !containerRef.current) return;
      e.preventDefault();
      const x = e.pageX - containerRef.current.offsetLeft;
      const walk = (x - startX) * 2;
      containerRef.current.scrollLeft = scrollLeft - walk;
    };

    const configTypes:ConfigDashboardTypes[] = useSelector(() => store.getState().configTypeState.configDashboardTypes)
    const activeOption:string = useSelector(() => store.getState().configTypeState.activeOption)
    const navigate = useNavigate();
    
    const handleConfigTypeOnClick = (id: string, index: number) => {

        let isDayEndInProgress = checkDayEndStatus()
        if (!isFeatureValid(id) && isDayEndInProgress) {
          dispatch(setDayEndPopup(true))
          return ;
        }
        const activeSideBarOption = updateActiveConfigType(id);
        if(activeSideBarOption){
            navigate(activeSideBarOption.route)
            if(routesRequiringClientConfigFetch?.includes(activeSideBarOption?.navbarParentLabel)) fetchAndStoreClientConfig()
                if (activeSideBarOption && containerRef.current) {
                    const tile = containerRef.current.children[index] as HTMLElement;
                    const containerWidth = containerRef.current.offsetWidth;
                    const tileWidth = tile.offsetWidth;
                    const tileLeft = tile.offsetLeft;
                    const scrollPosition = tileLeft - (containerWidth - tileWidth) / 2;
                    containerRef.current.scrollTo({
                      left: scrollPosition,
                      behavior: 'smooth',
                    });
                }
             
        }
    }
    return (
      <div
        className="navbar-configuration-type"
        ref={containerRef}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseUp}
      >
        {/* {configTypes.map((config, index) => (
          <NavbarConfigurationTile
            key={config.id}
            label={translate(TranslationEnum.navbar_options,config.label)}
            activeNavbar={config.label}
            active={activeOption === config.id}
            onClick={() => {
              handleConfigTypeOnClick(config.id, index);
            }}
            icon={config.icon}
          />
        ))} */}
        {configTypes.map((config, index) => (
        <div
          key={config.id}
          tabIndex={0}
          role="button"
          aria-pressed={activeOption === config.id}
          className="navbar-config-tile-wrapper"
          onClick={() => handleConfigTypeOnClick(config.id, index)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              handleConfigTypeOnClick(config.id, index);
            } else if (e.key === "ArrowRight" && index < configTypes.length - 1) {
              const nextTile = containerRef.current?.children[index + 1] as HTMLElement;
              nextTile?.scrollIntoView({ behavior: "smooth", inline: "center" });
              nextTile?.focus();
            } else if (e.key === "ArrowLeft" && index > 0) {
              const prevTile = containerRef.current?.children[index - 1] as HTMLElement;
              prevTile?.scrollIntoView({ behavior: "smooth", inline: "center" });
              prevTile?.focus();
            }
          }}
        >
          <NavbarConfigurationTile
            key={config.id}
            label={translate(TranslationEnum.navbar_options,config.label)}
            activeNavbar={config.label}
            active={activeOption === config.id}
            onClick={() => {
              handleConfigTypeOnClick(config.id, index);
            }}
            icon={config.icon}
          />
        </div>
      ))}
      </div>
    );
}
